<template>
  <div class="page">

    <div
      class="groups-query-list card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h1 class="title">Criar Template</h1>
        </div>
      </div>

      <div class="body">
        <div>
          <form action="" @submit.prevent>
            <div class="input-group">
              <label for="name" class="label w-full">Nome do template</label>
              <input
                class="form-control"
                id="name"
                type="text"
                placeholder="Nome do template"
                v-model="name"
                autocomplete
                required
              >
              <button type="button" class="btn btn-success" @click="createTemplate">
                <ion-icon name="save"></ion-icon> Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'Create',

  components: {
    Loader,
  },

  data() {
    return {
      name: '',
      loading: false,
    };
  },

  computed: {
    ...mapState('template', [
      'template',
    ]),
  },

  methods: {
    async createTemplate() {
      this.loading = true;
      await this.$store.dispatch('template/createTemplate', {
        name: this.name,
        tag: 'cnpj',
      });
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: 'Template criado com sucesso.',
      });
      this.loading = false;
      await this.$router.push({
        name: 'Template-Legal-Person',
      });
    },
  },

  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>
